import ClaimStatus from '@product-framework/components/ClaimStatus';
import Currency from '@product-framework/components/Currency';
import { DATE_FORMAT, truncateText } from '@ui-framework/index';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

function serviceJobNumber(original) {
  const editLink = `/servicejobs/edit/${original?.serviceJob?.id}`;
  return (
    <Link to={editLink}>{original?.serviceJob?.serviceJobNumber || ''}</Link>
  );
}

function claimNumber(original) {
  const editLink = `/servicejobs/edit/${
    original?.serviceJob?.id || original?.serviceJobId
  }?claimid=${original?.id}`;
  return <Link to={editLink}>{original?.claimNumber || ''}</Link>;
}

function claimStatus(original) {
  return <ClaimStatus>{original?.claimStatus}</ClaimStatus>;
}

function claimStatusDate(original) {
  return original?.claimStatusDate
    ? dayjs(original?.claimStatusDate).format(DATE_FORMAT.LONG_DATE)
    : '';
}

function serviceDate(original) {
  return original?.serviceDate
    ? dayjs(original?.serviceDate).format(DATE_FORMAT.LONG_DATE)
    : '';
}

function serviceProviderName(original) {
  return original?.serviceJob?.serviceProvider?.name;
}

function servicePerformed(original) {
  return truncateText(original?.servicePerformed) || '';
}

function totalApproved(original) {
  return <Currency>{original?.totalApproved}</Currency>;
}

function customerName(original) {
  const firstName = original?.serviceJob?.customerNameFirst || '';
  const lastName = original?.serviceJob?.customerNameLast || '';
  return `${firstName} ${lastName}`;
}

function customerAddress(original) {
  const address1 = original?.serviceJob?.customerAddressStreet || '';
  const city = original?.serviceJob?.customerCity || ''; // not in api
  const state = original?.serviceJob?.customerAddressState.name || '';
  const zip = original?.serviceJob?.customerAddressPostalCode || '';
  const country =
    original?.serviceJob?.customerAddressCountry.countryName || '';
  return `${address1}\n ${city}, ${state} ${zip} ${country}`;
}

function productLine(original) {
  return original?.serviceJob?.productType?.productLineName || '';
}

function brand(original) {
  return original?.serviceJob?.brand?.brandName || '';
}

function customerComplaint(original) {
  return truncateText(original?.serviceJob?.customerComplaint) || '';
}

function lastUpdatedDate(original) {
  return original?.lastModifiedDateTime
    ? dayjs(original?.lastModifiedDateTime).format(DATE_FORMAT.LONG_DATE)
    : '';
}

function appointmentDate(original) {
  return original?.serviceJob?.appointmentDate
    ? dayjs(original?.serviceJob?.appointmentDate).format(DATE_FORMAT.LONG_DATE)
    : '';
}

export {
  claimNumber,
  claimStatus,
  serviceDate,
  serviceJobNumber,
  serviceProviderName,
  servicePerformed,
  totalApproved,
  customerName,
  customerAddress,
  productLine,
  brand,
  customerComplaint,
  lastUpdatedDate,
  appointmentDate,
  claimStatusDate,
};
